import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { getDefaultRoute } from '../utils/permissions';

/**
 * Sends the user to the right landing page for their role:
 * Dashboard for admins and inspectors, Inspections for staff
 * (staff has no Dashboard access).
 */
export function RootRedirect() {
  const { user } = useAuthStore();
  const token = localStorage.getItem('accessToken');

  // Used as the catch-all route too, which sits outside ProtectedRoute
  if (!user && !token) {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to={getDefaultRoute(user?.role)} replace />;
}
